import { Dispatch, Constants } from '../../../../../core';
import {environment} from '../../../../../../environments/environment';

const iconsOfActions = [
  {
    icon: 'check-circle-regular',
    tooltip: 'Actualizar',
    hasVisibleCondition: (element: Dispatch[]): boolean => {
      if (element && element.length && element.length > 0) {
        return element[0].dispatchItems.state !== Constants.statusDispatch.DELIVERED 
        && element[0].dispatchItems.state !== Constants.statusDispatch.PENDING_CUSTOMER_COLLECT;
      }
      return true;
    }
  },
  {
    icon: 'printer',
    tooltip: 'Imprimir',
    hasVisibleCondition: (element: Dispatch[]): boolean => {
      if (element && element.length && element.length > 0) {
        return element[0].dispatchItems.state === Constants.statusDispatch.PENDING_PICKING ? true : false;
      }
      return false;
    }
  },
  {
    icon: 'cancel',
    tooltip: 'Pre-cancelar',
    hasVisibleCondition: (element: Dispatch[]): boolean => {
      return element && element.length
        ?
        element[0].dispatchItems.state === Constants.statusDispatch.PENDING_PICKING
        && element[0].dispatchItems.currentPickingSystem
        && element[0].dispatchItems.currentPickingSystem === element[0].dispatchItems.availablePickingSystem
        : false;
    }
  }
];

export const confirmationDispatches = {
  hasDisabledCheckBoxItem: (row: Dispatch, selection: any) => {
    const state = Constants.statusDispatch;
    const session = JSON.parse(localStorage.getItem(environment.sessionAuth));
    if (row) {
      if (typeof (row.dispatchItems) === 'object') {
          if (row.isRedExterna
            && row.dispatchItems.state === state.PENDING_RETURNED_ORIGIN) { 
            return false;
          }
          if ((row.dispatchItems.canceledAmount === row.dispatchItems.pendingAmount &&
            (row.dispatchItems.state === state.PENDING_PICKING ||
              row.dispatchItems.state === state.PENDING_CUSTOMER_DISPATCH ||
              row.dispatchItems.state === state.PENDING_RECEPTION_PROVIDER)) ||
            row.dispatchItems.pendingAmount === 0) {
            return true;
          } else {
            return false;
          }
      }
    }
    return false;
  },
  classValidation: (row: any) => {
    if ((row && row.dispatchItems && row.dispatchItems.isCancelled &&
      row.dispatchItems.canceledAmount === row.dispatchItems.pendingAmount)
      || row.dispatchItems.pendingAmount === 0) {
      return 'pending';
    }
    return '';
  },
  searchText: 'Buscar despacho',
  paginator: true,
  checkbox: true,
  filter: false,
  filterDefault: '',
  iconsOfActions: iconsOfActions,
  exportFile: 'confirmación_despacho.xlsx',
  columns: [
    {
      title: 'Compañia',
      name: 'companyCode',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.companyCode
    },
    {
      title: 'Nota de Venta',
      name: 'saleNoteId',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.saleNoteId
    },
    {
      title: 'Despacho',
      name: 'dispatchId',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches-dispatch',
      value: (element: Dispatch) => element.dispatchId
    },
    {
      title: 'LPN',
      name: 'lpn',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.lpn
    },
    {
      title: 'Código SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) =>
        element.dispatchItems.skuCode + '-' + element.dispatchItems.skuPartialSequence
    },
    {
      title: 'Cant. Total',
      name: 'pendingAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches-pendingAmount',
      value: (element: Dispatch) => element.dispatchItems.pendingAmount + ((element.dispatchItems.canceledAmount != null) ? element.dispatchItems.canceledAmount : 0)
    },
    {
      title: 'Cant. Cancelada',
      name: 'canceledAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches-canceledAmount',
      value: (element: Dispatch) => (element.dispatchItems.canceledAmount != null) ? element.dispatchItems.canceledAmount : 0
    },
    {
      title: 'Descripción',
      name: 'skuName',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches-skuName',
      value: (element: Dispatch) => element.dispatchItems.skuName.replace('�', '')
    },
    {
      title: 'Fecha estado actual',
      name: 'stateDate',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.dispatchItems.stateDate
    },
    {
      title: 'Fecha de entrega',
      name: 'deliveryDate',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.deliveryDate
    },
    {
      title: 'Inicio ventana horaria',
      name: 'startDateDeliveryWindow',
      type: 'string',
      class: 'center confirmationDispatches',
      sortServer: true,
      value: (element: Dispatch) => element.startDateDeliveryWindow
    },
    {
      title: 'Fin ventana horaria',
      name: 'endDateDeliveryWindow',
      type: 'string',
      class: 'center confirmationDispatches',
      sortServer: true,
      value: (element: Dispatch) => element.endDateDeliveryWindow
    },
    {
      title: 'Modalidad de despacho',
      name: 'deliveryTypeName',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches-deliveryTypeName',
      value: (element: Dispatch) => element.deliveryTypeName
    },
    {
      title: 'Sucursal de venta',
      name: 'saleLocationName',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.saleLocationName
    },
    {
      title: 'Estado de Pago',
      name: 'paymentDate',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => { return element.paymentDate ? 'Pagado' : 'Pendiente de pago' }
    },
    {
      title: 'Origen despacho',
      name: 'ecommerceId',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => { return element.ecommerceId ? 'Ecommerce' : 'DaD' }
    },
    {
      title: 'Nro. Doc',
      name: 'customerDocumentNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.customerDocumentNumber
    },
    {
      title: 'Cliente',
      name: 'customer',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.customer
    },
    {
      title: 'Estado',
      name: 'state',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.dispatchItems.state
    },
    {
      title: 'Entidad Actual',
      name: 'currentEntityName',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.dispatchItems.currentEntityName
    },
    {
      title: 'Ruta',
      name: 'route',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches-route',
      value: (element: Dispatch) => element.route
    },
    {
      title: 'Ubicación',
      name: 'location',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches-loation',
      value: (element: Dispatch) => element.dispatchItems.location
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeName',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      class: 'confirmationDispatches',
      value: (element: Dispatch) => element.dispatchTypeName
    },
    {
      title: 'Imagen',
      type: 'button',
      name: 'image',
      editable: false,
      checkAll: false,
      class: 'center',
      value: () => {
        return {
          icon: 'photo',
          svg: true,
          tooltip: 'Ver detalles del producto',
          class: 'recordColumn icon-table'
        };
      }
    }
  ]
};
